import { Component } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { LoaderService, LoaderState } from '../loader-service';

@Component({
  selector: 'app-new-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  
    show = false;
    private subscription: Subscription;

  constructor(private loaderService: LoaderService){}

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
        .subscribe((state: LoaderState) => {
        this.show = state.show;
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}